import { useState, useEffect } from "react"
import axios from "axios"
import { ModelPair } from "../components/KmControls"
import { useLogger } from "src/providers"
import { useLocalStorage } from "src/utils/useLocalStorage"

interface UseModelsProps {
  endpoint: string
}

const LEGACY_MODEL_KEYS: Record<string, string> = {
  litellm_llama4: "litellm_glimmer"
}

const resolveModelKey = (modelKey: string) => LEGACY_MODEL_KEYS[modelKey] ?? modelKey

const migrateStoredModel = (value: ModelPair, models: ModelPair[]): ModelPair => {
  const resolvedKey = resolveModelKey(value.model)
  if (resolvedKey === value.model) {
    return value
  }
  return models.find((m) => m.model === resolvedKey) ?? { model: resolvedKey, name: "Meta Glimmer" }
}

export const useModels = ({ endpoint }: UseModelsProps) => {
  const [models, setModels] = useState<ModelPair[]>([])
  const [model, setModel] = useLocalStorage<ModelPair>(
    "model",
    models[0],
    (value: ModelPair) =>
      models.length == 0 || models.some((m) => m.model === resolveModelKey(value.model)),
    [models]
  )
  const { logger } = useLogger()

  useEffect(() => {
    axios
      .get(endpoint)
      .then((response) => {
        const fetchedModels = response.data
        setModels(fetchedModels)

        if (model?.model) {
          const migrated = migrateStoredModel(model, fetchedModels)
          if (migrated.model !== model.model || migrated.name !== model.name) {
            setModel(migrated)
          }
        }
      })
      .catch((error) => {
        logger.error("Error fetching models:", error)
      })
  }, [endpoint])

  return {
    models,
    model,
    setModel
  }
}
